import React from "react";
import {
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";

interface ErrorAlertProps {
  message: string;
  type?: "error" | "warning" | "info" | "success";
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, type = "error" }) => {
  const configs = {
    error: {
      bgColor: "bg-red-50",
      borderColor: "border-red-200",
      textColor: "text-red-600",
      iconColor: "text-red-400",
      Icon: ExclamationCircleIcon,
    },
    warning: {
      bgColor: "bg-yellow-50",
      borderColor: "border-yellow-200",
      textColor: "text-yellow-800",
      iconColor: "text-yellow-400",
      Icon: ExclamationTriangleIcon,
    },
    info: {
      bgColor: "bg-blue-50",
      borderColor: "border-blue-200",
      textColor: "text-blue-800",
      iconColor: "text-blue-400",
      Icon: InformationCircleIcon,
    },
    success: {
      bgColor: "bg-green-50",
      borderColor: "border-green-200",
      textColor: "text-green-800",
      iconColor: "text-green-400",
      Icon: CheckCircleIcon,
    },
  };

  const config = configs[type];
  const Icon = config.Icon;

  return (
    <div
      className={`${config.bgColor} border ${config.borderColor} ${config.textColor} px-4 py-3 rounded flex items-start`}
    >
      <Icon className={`h-5 w-5 ${config.iconColor} mr-3 flex-shrink-0 mt-0.5`} />
      <p>{message}</p>
    </div>
  );
};

export default ErrorAlert;

